module.exports = " <div class=weui_cell> <div class=\"weui_cell_bd weui_cell_primary\"> <textarea class=weui_textarea :autocomplete=autocomplete :autocapitalize=autocapitalize :autocorrect=autocorrect :spellcheck=spellcheck :placeholder=placeholder :name=name :rows=rows :cols=cols v-model=value :style=textareaStyle :maxlength=max></textarea> <div class=weui_textarea_counter v-show=\"showCounter && max\"><span>{{count}}</span>/{{max}}</div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/x-textarea/index.vue
// module id = 267
// module chunks = 2